import api from './Api'; // Adjust the path based on your project structure

const BASE_URL = 'siteLinks/';

export default {
    getAll: () => {
        return api.get(BASE_URL);
    },
    getMapped: () => {
        return api.get(`${BASE_URL}mapped`);
    },
    getUnmapped: () => {
        return api.get(`${BASE_URL}unmapped`);
    },
    getUnmappedForAutomapping: () => {
        return api.get(`${BASE_URL}unmapped-for-automapping`);
    },
    mapCampaignToSiteBrandLink: (campaignId, siteBrandLinkId) => {
        return api.put(`${BASE_URL}map`, { campaignId, siteBrandLinkId });
    },
    unmapCampaign: (campaignId, siteBrandLinkId) => {
        return api.put(`${BASE_URL}unmap`, { campaignId, siteBrandLinkId });
    }, 
    getAllForCsvExport: () => {
        return api.get(`${BASE_URL}csv`);
    },
    updateSiteBrandLink: (id, updateData) => {
        return api.put(`${BASE_URL}${id}`, updateData);
    },
    updateSiteBrandLinkAlias: (id, alias) => {
        return api.put(`${BASE_URL}${id}/alias`, { alias });
    },
    getAffiliateSystem: (id) => {
        return api.get(`${BASE_URL}${id}/affiliate-system`);
    },
    /**
     * Sites this link may be moved to — the same publisher's approved sites only.
     * The backend enforces the same-publisher rule regardless of what we send.
     */
    getMoveTargets: (siteBrandLinkId) => {
        return api.get(`${BASE_URL}${siteBrandLinkId}/move-targets`);
    },
    /**
     * Move the link to another site owned by the same publisher. Also moves
     * Campaign.siteId, which is what earnings reporting reads.
     */
    moveToSite: (siteBrandLinkId, targetSiteId) => {
        return api.put(`${BASE_URL}${siteBrandLinkId}/move-site`, { targetSiteId });
    },
    updateCPAPostback: (siteBrandLinkId, cpaPostbackUrl) => {
        return api.put(`${BASE_URL}${siteBrandLinkId}/cpa-postback`, { cpaPostbackUrl });
    },
    updateFTDPostback: (siteBrandLinkId, ftdPostbackUrl) => {
        return api.put(`${BASE_URL}${siteBrandLinkId}/ftd-postback`, { ftdPostbackUrl });
    },
    updateRegisterPostback: (siteBrandLinkId, registerPostbackUrl) => {
        return api.put(`${BASE_URL}${siteBrandLinkId}/register-postback`, { registerPostbackUrl });
    },
    softDeleteSiteBrandLink: (siteBrandLinkId) => {
        return api.delete(`${BASE_URL}${siteBrandLinkId}`);
    }
};
